export enum NotificacaoInscricaoOrigemEnum {
    CLASSIND,
    PORTAL
}
